import React, { useState } from "react";
import { Row, Col } from "@ui/wrapper";
import PropTypes from "prop-types";
import { StyleECard, StyledBG } from "./style";
import ImageOne from "@data/images/about-us/e-card.png";
import Image from "@ui/image";
import { StaticImage } from "gatsby-plugin-image";
import { justifyContent } from "styled-system";
const ECard = (data) => {
    return (
        <>
            <StyleECard>
                <Row>
                    <Col lg={{ span: 4, order: 1 }} xs={{ span: 12, order: 1 }}>
                        <StaticImage
                            src="../../../assets/images/logo/dark-logo-160x48 - 副本.png"
                            alt="物联网设备"
                            width={120}
                            height={120}
                            style={{ marginLeft: "35px", textAlign: "center" }}
                        />
                    </Col>
                    <Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 2 }}>
                        <div
                            style={{
                                textAlign: "justify",
                                width: "100%",
                                lineHeight: "24px",
                                paddingTop: "12px",
                                color: "black",
                            }}
                        >
                            {/* <div
                                style={{
                                    fontSize: "21px",
                                    letterSpacing: "4px",
                                    fontWeight: 550,
                                }}
                            >
                                宁波九荣环保科技有限公司
                            </div> */}
                            {/* <p
                                style={{
                                    letterSpacing: "-0.3px",
                                    fontSize: "14px",
                                    color: "#626363",
                                }}
                            >
                                Zhejiang Rthink Intelligent Technology Co.,LTD
                            </p> */}
                            <div
                                style={{
                                    fontSize: "21px",
                                    letterSpacing: "4px",
                                    fontWeight: 550,
                                }}
                            >
                                宁波九荣环保科技有限公司
                            </div>
                            <p
                                style={{
                                    letterSpacing: "-0.8px",
                                    fontSize: "14px",
                                    color: "#626363",
                                }}
                            >
                                Ningbo Jolong Environmental Technology Co.,LTD
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col
                        lg={{ span: 4, order: 1 }}
                        xs={{ span: 12, order: 1 }}
                    ></Col>
                    <Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 2 }}>
                        <div
                            style={{
                                background: "#3162aa",
                                height: "4px",
                                width: "100%",
                                marginTop: "20px",
                            }}
                        ></div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 4, order: 1 }} xs={{ span: 12, order: 1 }}>
                        <div
                            style={{
                                paddingLeft: "30px",
                                textAlign: "center",
                                paddingTop: "20px",
                            }}
                        >
                            <p style={{ fontSize: "16px", lineHeight: "30px" }}>
                                <span
                                    style={{
                                        fontSize: "26px",
                                        fontWeight: "550px",
                                    }}
                                >
                                    干双九
                                </span>
                                <br />
                                业务经理
                                <br />
                                13738880544
                            </p>
                        </div>
                    </Col>
                    <Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 2 }}>
                        <div>
                            <p style={{ fontSize: "14px", paddingTop: "22px" }}>
                                地址：浙江省宁波市镇海区九龙湖镇田顾工业区
                                <br />
                                电话：0574-86528526&nbsp;传真：0574-86528525
                                <br />
                                邮箱：gansj@rthinkai.com
                                <br />
                                公司网址：http://www.rthinkai.com/
                            </p>
                        </div>
                    </Col>
                </Row>
            </StyleECard>
            <br />
            <StyleECard>
                <Row>
                    <Col lg={{ span: 4, order: 1 }} xs={{ span: 12, order: 1 }}>
                        <StaticImage
                            src="../../../assets/images/logo/dark-logo-160x48 - 副本.png"
                            alt="物联网设备"
                            width={120}
                            height={120}
                            style={{ marginLeft: "35px", textAlign: "center" }}
                        />
                    </Col>
                    <Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 2 }}>
                        <div
                            style={{
                                textAlign: "justify",
                                width: "100%",
                                lineHeight: "24px",
                                paddingTop: "12px",
                                color: "black",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "21px",
                                    letterSpacing: "4px",
                                    fontWeight: 550,
                                    marginTop: "24px",
                                }}
                            >
                                宁波九荣环保科技有限公司
                            </div>
                            <p
                                style={{
                                    letterSpacing: "-0.3px",
                                    fontSize: "14px",
                                    color: "#626363",
                                }}
                            >
                                Zhejiang Rthink Intelligent Technology Co.,LTD
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col
                        lg={{ span: 4, order: 1 }}
                        xs={{ span: 12, order: 1 }}
                    ></Col>
                    <Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 2 }}>
                        <div
                            style={{
                                background: "#3162aa",
                                height: "4px",
                                width: "100%",
                                marginTop: "20px",
                            }}
                        ></div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 4, order: 1 }} xs={{ span: 12, order: 1 }}>
                        <div
                            style={{
                                paddingLeft: "30px",
                                textAlign: "center",
                                paddingTop: "20px",
                            }}
                        >
                            <p style={{ fontSize: "16px", lineHeight: "30px" }}>
                                <span
                                    style={{
                                        fontSize: "26px",
                                        fontWeight: "550px",
                                    }}
                                >
                                    吴丹妮
                                </span>
                                <br />
                                行政经理
                                <br />
                                400-996-6706
                            </p>
                        </div>
                    </Col>
                    <Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 2 }}>
                        <div>
                            <p style={{ fontSize: "14px", paddingTop: "30px" }}>
                                地址：浙江省宁波市镇海区天一大厦7楼
                                <br />
                                电话：400-996-6706&nbsp;
                                <br />
                                公司网址：http://www.rthinkai.com/
                            </p>
                        </div>
                    </Col>
                </Row>
            </StyleECard>
        </>
    );
};

ECard.propTypes = {
    data: PropTypes.string,
};

export default ECard;
